/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import reduxForm from 'redux-form/es/reduxForm';
import Field from 'redux-form/es/Field';
import axios from 'axios';
import Button from 'components/common/Button';
import InputField from 'components/Credit24/Core/Controls/InputField';
import { toUpper } from 'utils/helpers';

const propTypes = {
  onCancelClick: PropTypes.func,
  handleSubmit: PropTypes.func,
  onIBANSubmitClick: PropTypes.func,
};

const WithdrawalIBANConfirmation = (props) => (
  <div className="confirmation-block">
    <form onSubmit={props.handleSubmit(props.onIBANSubmitClick)}>
      <div className="confirmation-block__content">
        <h3 className="confirmation-block__title">
          <FormattedMessage id="selfservice.withdrawalConfirmation.title" />
        </h3>
        <p>
          <FormattedMessage id="selfservice.withdrawalConfirmation.iban.description" />
        </p>
        <Field
          title={<FormattedMessage id="customer.field.bankAccount" />}
          name="bankAccount"
          type="text"
          hintConfig={{ titleKey: 'hint.field.bankAccount' }}
          component={InputField}
          normalize={toUpper}
          isFullWidth
          autoFocus
        />
      </div>
      <nav className="confirmation-block__navigation">
        <div className="btn-group">
          <Button btnType="secondary" type="button" onClick={props.onCancelClick}>
            <FormattedMessage id="selfservice.withdrawalConfirmation.cancel" />
          </Button>
          <Button>
            <FormattedMessage id="selfservice.withdrawalConfirmation.iban.next" />
          </Button>
        </div>
      </nav>
    </form>
  </div>
);

WithdrawalIBANConfirmation.propTypes = propTypes;

const withdrawalFormConfig = {
  form: 'withdrawalIBANForm',
  asyncValidate: (values) => {
    const { bankAccount } = values;
    return axios.post(
      `${API_HOST}/customer/bankaccount/validation`,
      { bankAccount },
      { hideError: true }
    ).then(() => Promise.resolve({})).catch(() => ({ bankAccount: 'errors.field.iban' }));
  },
  validate: (values) => {
    const errors = {};
    if (!values.bankAccount) {
      errors.bankAccount = 'errors.field.required';
    }
    return errors;
  },
  onSubmitFail: (error) => {
    if (DEBUG) {
      console.warn('form submit fail', error);
    }
  },
};

export default reduxForm(withdrawalFormConfig)(WithdrawalIBANConfirmation);
